import ApiService from './api';
import type { Faq, FaqCategory, FaqResponse, FaqCategoryResponse, FaqsByCategoryResponse } from '~/types/api';

/**
 * Sık Sorulan Sorular için API işlemleri
 */
export default class FaqService {
  private static instance: FaqService;
  private apiService: ApiService;
  private faqsEndpoint: string = '/public/faqs';
  private categoriesEndpoint: string = '/public/faqs/categories';

  private constructor() {
    this.apiService = ApiService.getInstance();
  }

  /**
   * Singleton örneği al
   */
  public static getInstance(): FaqService {
    if (!FaqService.instance) {
      FaqService.instance = new FaqService();
    }
    return FaqService.instance;
  }

  /**
   * Tüm aktif SSS kategorilerini getir
   * @param lang Dil kodu (örn: tr, en)
   */
  public async getActiveCategories(lang: string = 'tr'): Promise<FaqCategory[]> {
    try {
      const response = await this.apiService.get<FaqCategory[]>(this.categoriesEndpoint, { lang });
      
      if (response.status === 200 && response.data) {
        return response.data;
      }
      
      return [];
    } catch (error) {
      console.error('SSS kategorileri alınırken hata oluştu:', error);
      return [];
    }
  }

  /**
   * Tüm aktif SSS'leri getir
   * @param lang Dil kodu (örn: tr, en)
   */
  public async getAllFaqs(lang: string = 'tr'): Promise<Faq[]> {
    try {
      const response = await this.apiService.get<Faq[]>(this.faqsEndpoint, { lang });
      
      if (response.status === 200 && response.data) {
        return response.data;
      }
      
      return [];
    } catch (error) {
      console.error('SSS listesi alınırken hata oluştu:', error);
      return [];
    }
  }

  /**
   * Belirli bir kategoriye ait SSS'leri getir
   * @param categoryId Kategori ID
   * @param lang Dil kodu (örn: tr, en)
   */
  public async getFaqsByCategory(categoryId: number, lang: string = 'tr'): Promise<FaqsByCategoryResponse | null> {
    try {
      const response = await this.apiService.get(`${this.categoriesEndpoint}/${categoryId}`, { lang });
      
      if (response.status === 200) {
        // API yanıtı doğrudan FaqsByCategoryResponse formatında
        return response as unknown as FaqsByCategoryResponse;
      }
      
      return null;
    } catch (error) {
      console.error(`Kategori ID: ${categoryId} için SSS'ler alınırken hata oluştu:`, error);
      return null;
    }
  }
} 